import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';

// Sortable table header.
// Použití s useSortable hookem:
//   const { sortKey, sortDir, toggleSort, sorted } = useSortable(items, 'name');
//   <SortableTh column="name" sortKey={sortKey} sortDir={sortDir} onSort={toggleSort}>
//     Název
//   </SortableTh>
//
// Cycle: asc → desc → none při opakovaném kliku na stejný sloupec.

export default function SortableTh({
  column,
  sortKey,
  sortDir,
  onSort,
  children,
  className = '',
  align = 'left',
}) {
  const active = sortKey === column;
  const alignClass = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';

  return (
    <th
      onClick={() => onSort(column)}
      className={`cursor-pointer select-none transition-opacity hover:opacity-80 ct-eyebrow py-2 px-3 ${alignClass} ${className}`}
    >
      <span className={`inline-flex items-center gap-1 ${align === 'right' ? 'flex-row-reverse' : ''}`}>
        {children}
        {active ? (
          sortDir === 'asc'
            ? <ChevronUp className="w-3 h-3" style={{ color: 'var(--ct-accent)' }} />
            : <ChevronDown className="w-3 h-3" style={{ color: 'var(--ct-accent)' }} />
        ) : (
          <ChevronsUpDown className="w-3 h-3 opacity-40" />
        )}
      </span>
    </th>
  );
}
